import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { TotalsService } from '@app/@shared/models/graphs/services/totals.service';
import { FailureModeDisplayMode } from '@shared/models/graphs/enums/failure-mode-display-mode.enum';

@Component({
  selector: 'app-graph-footer',
  templateUrl: './graph-footer.component.html',
  styleUrls: ['./graph-footer.component.scss'],
})
export class GraphFooterComponent implements OnInit {
  @Input() showLegends = true;
  @Input() showLabels = true;
  @Input() showLabelsCheckboxVisible = true;
  @Input() isFailureMode = false;

  @Output() showLegendsChanged = new EventEmitter<boolean>();
  @Output() showLabelsChanged = new EventEmitter<boolean>();
  @Output() buttonExportAsImageClicked = new EventEmitter<void>();
  @Output() buttonExportAsExcelClicked = new EventEmitter<void>();
  @Output() buttonExportDataClicked = new EventEmitter<void>();
  @Output() onTotalChangeEmitter = new EventEmitter<FailureModeDisplayMode>();

  readonly failureModeDisplayMode = FailureModeDisplayMode;

  constructor(public totalsService: TotalsService) {}
  ngOnInit(): void {}

  onDisplayModeChange(event: MatRadioChange) {
    this.totalsService.displayMode = event.value;
    this.onTotalChangeEmitter.emit(event.value);
  }
}